import {
  GameModel,
  IAPAdapterInterface,
  PurchaseService,
} from "@citychallenge/core";

export class IAPAdapter implements IAPAdapterInterface {
  public async serviceWillMount(_service: PurchaseService) {
    // TODO: Implement
  }

  public async serviceWillUnmount() {
    // TODO: Implement
  }
  public async hydrateProducts(_games: GameModel[]) {
    // TODO: Implement
  }

  public async restorePurchases() {
    // TODO: Implement
  }

  public async startPurchase(_game: GameModel) {
    // TODO: Implement
    return false;
  }
}
